// This cookie is set by OneTrust; see
// https://developer.onetrust.com/onetrust/docs/onetrust-cookies#optanonconsent

import {CookieCategory} from "./types.ts";

// sync-start:consent-cookie-name 1515659215 https://github.com/Khan/webapp/blob/master/pkg/web/cookie_consent.go
export const consentCookieName = "OptanonConsent";
// sync-end:consent-cookie-name

// Countries where the model is "opt-out" -- i.e., in the absence of
// consent data, all cookies are permitted because the user must opt-out of
// any they do not wish to allow. This name might be a bit confusing since
// WE'RE effectively opting them "in" to cookies, but the naming here aligns
// with how this model is referred to in compliance contexts at large, where
// "opt-out" or "opt-in" models refer to what action the USER may take.
//
// This set of countries is based on what our legal team has determined to
// be appropriate, and should stay aligned with what they've configured in
// the OneTrust app.
// sync-start:cookie-consent-opt-out 1106727138 https://github.com/Khan/webapp/blob/master/pkg/web/cookie_consent.go
export const optOutCountries: ReadonlyArray<string> = [
    // All countries should be represented by their (uppercase) 2-character
    // ISO-3166-2 code
    "IN", // India
    "PE", // Peru
    "US", // United States
];
// sync-end:cookie-consent-opt-out

// Mapping of keys defined in the OneTrust cookie to the CookieCategory enum
// See parseConsentCookie for more details
// sync-start:consent-category-map 624453000 https://github.com/Khan/webapp/blob/master/pkg/web/cookie_consent.go
export const oneTrustCookieKeyToCategory: Map<string, CookieCategory> = new Map(
    [
        ["C0001", CookieCategory.StrictlyNecessary],
        ["C0002", CookieCategory.Performance],
        ["C0003", CookieCategory.Functional],
        ["C0004", CookieCategory.Targeting],
    ],
);
// sync-end:consent-category-map
